import Script from 'next/script';
import { ENV } from '@/config/env';

export function LoadCaptcha() {
  return <Script src={`https://www.google.com/recaptcha/api.js?render=${ENV.GOOGLE_SITE_KEY}`} />;
}
